import { combineReducers } from "redux"
import clusters from "./clusters"

const clusterReducer = combineReducers({
  clusters,
})

export default clusterReducer
